import { apiWithAuth } from "@/modules/auth";
import { TonProofPayload } from "../types/tonProofPayload";

export const validateTonProof = async (proofPayload: TonProofPayload) => {
  const response = await apiWithAuth.post("/wallet/validate", proofPayload);
  return response.data;
};

export const fetchTonProofPayload = async (): Promise<string | null> => {
  const response = await apiWithAuth.get("/wallet/payload");
  return response.data?.payload || null;
};
